import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

const Landing = lazy(() => import("../pages/Landing"));
const BookDemo = lazy(() => import("../pages/BookDemo"));
const Resources = lazy(() => import("../pages/Resources"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const CarbonReduction2024 = lazy(() => import("../pages/CarbonReduction2024"));
const Careers = lazy(() => import("../pages/Careers"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const Contact = lazy(() => import("../pages/Contact"));
const Tram = lazy(() => import("../pages/Tram"));
const Dytask = lazy(() => import("../pages/Dytask"));
const Deams = lazy(() => import("../pages/Deams"));
const EssVideo = lazy(() => import("../pages/essVideo"));
const Police = lazy(() => import("../pages/Police"));
const Fire = lazy(() => import("../pages/Fire"));
const Government = lazy(() => import("../pages/Government"));
const Education = lazy(() => import("../pages/Education"));
const Aviation = lazy(() => import("../pages/Aviation"));
const CookiePolicy = lazy(() => import("../pages/CookiePolicy"));
const NotFound = () => <div className="not-found-container">404 – Page Not Found</div>;

export const AppRoutes = () => (
  <Suspense fallback={<div className="page-loading"></div>}>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/bookdemo" element={<BookDemo />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/carbon-reduction-23-24" element={<CarbonReduction2024 />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/tram" element={<Tram />} />
      <Route path="/dytask" element={<Dytask />} />
      <Route path="/deams" element={<Deams />} />
      <Route path="/ess-video" element={<EssVideo />} />
      <Route path="/police" element={<Police />} />
      <Route path="/fire" element={<Fire />} />
      <Route path="/government" element={<Government />} />
      <Route path="/education" element={<Education />} />
      <Route path="/aviation" element={<Aviation />} />
      <Route path="/cookiepolicy" element={<CookiePolicy />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
);
